// ── Section ✦ — reusable shell for every parent dashboard block ─
import React from 'react';
import {
  PANEL, PANEL_BORDER, TEXT, TEXT_MUTED, TEXT_SOFT, BLUE, FONT_STACK,
} from './palette';

export const Section = ({ eyebrow, title, subtitle, children, testid, accent = BLUE }) => (
  <section
    data-testid={testid}
    style={{
      padding: '26px 22px',
      borderRadius: 22,
      marginBottom: 16,
      background: PANEL,
      border: `1px solid ${PANEL_BORDER}`,
      backdropFilter: 'blur(8px)',
    }}
  >
    {eyebrow && (
      <p style={{
        margin: 0, fontSize: 10.5, fontWeight: 700, letterSpacing: '0.32em',
        textTransform: 'uppercase', color: accent, opacity: 0.85,
      }}>{eyebrow}</p>
    )}
    {title && (
      <p style={{
        margin: '10px 0 4px', fontFamily: FONT_STACK, fontWeight: 700,
        fontSize: 19, color: TEXT, letterSpacing: '-0.01em', lineHeight: 1.3,
      }}>{title}</p>
    )}
    {subtitle && (
      <p style={{
        margin: '0 0 14px', color: TEXT_MUTED, fontSize: 13.5, lineHeight: 1.55,
      }}>{subtitle}</p>
    )}
    {!subtitle && title && <div style={{ height: 12 }} />}
    {children}
  </section>
);

// Warm placeholder for opted-out or empty sections. Never "No
// events" or "Nothing here" — calmness is constitutional.
export const CalmPlaceholder = ({ children, testid }) => (
  <p
    data-testid={testid}
    style={{
      margin: 0, color: TEXT_SOFT, fontSize: 13.5, lineHeight: 1.6,
      padding: '4px 0',
    }}
  >
    {children}
  </p>
);
